import axios from "axios";

export default axios.create({
  baseURL: "https://api.tipoffbw.com",
  headers: {
    //"Content-type": "application/json"
  }
});
